<!-- <div class="order-complete-container">
  <div class="order-complete-content">
    <mat-icon class="success-icon" color="primary">check_circle</mat-icon>

    <h1>Your Order Is Completed!</h1>

    <p class="mat-body-1">
      Thank you for your order! Your order is being processed and will be completed within 3-6 hours. You will receive an email confirmation when your order is completed.
    </p>

    <button mat-flat-button color="primary" class="continue-shopping-button">
      Continue Shopping
    </button>

    <mat-divider></mat-divider>

    <h2>Order Details</h2>
  </div>
</div> -->


<div class="order-success-wrapper container" [style.background-color]="item.customField8">
  <div class="order-success-box">
    <div class="check-circle">
      <img [style.height]="item.customField25" [style.width]="item.customField37"
        [ngStyle.lt-md]="{height: item.customField26, width: item.customField38}"
        [src]="serverPathLogo+item.customField6" [alt]="item.customField6.altImage || 'images'" />
    </div>

    <h2 class="headers">
      <calsoft-editor-text [data]="data" [text]="item?.title" [style.font-size]="item.customField31"
        [ngStyle.lt-md]="{ 'font-size': item.customField32 }">
      </calsoft-editor-text>
    </h2>

    <p class="order-message">
      <calsoft-editor-text [data]="data" [text]="item?.customField20" [style.font-size]="item.customField33"
        [ngStyle.lt-md]="{ 'font-size': item.customField34 }">
      </calsoft-editor-text>
    </p>

    <button [style.background-color]="item.customField10" [style.color]="item.customField36"
      [style.font-size]="item.customField29" [ngStyle.lt-md]="{ 'font-size': item.customField30 }"
      class="continue-button" (click)="navigateToHome()">{{item.customField24}}</button>

    <div fxLayout="row" fxLayoutGap="10px" style="padding: 20px;" fxLayoutAlign="center center">

      <div fxFlex="40" class="order-details-divider"></div>

      <h2 fxFlex [style.color]="item.customField35" [style.font-size]="item.customField27"
        [ngStyle.lt-md]="{ 'font-size': item.customField28 }" class="order-details-title">{{item.customField23}}</h2>
      <div fxFlex="40" class="order-details-divider"></div>
    </div>


    <div fxLayout="row wrap" fxLayoutAlign.lt-lg="center center" class="product-list">
      <div *ngFor="let item of orderItem" class="product-card" fxFlex="48" fxFlex.xs="100">
        <div class="card-content" (click)="order()" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">

          <div *ngIf="item.imageUrl!=null">
            <div
              *ngIf="!item.imageUrl.includes('commonimages')&&!item.imageUrl.includes('http')&&!item.imageUrl.includes('medicineimages')">

              <img *ngIf="item.imageUrl" src="{{ bigImage }}/{{ item.imageUrl }}"
               class="product-img"
                onerror="this.src='assets/images/products/noImage/no-image.png';" />
            </div>

            <div *ngIf="item.imageUrl.includes('http')">

              <img *ngIf="item.imageUrl" src="{{ item.imageUrl }}"
                 class="product-img"
                onerror="this.src='assets/images/products/noImage/no-image.png';" />
            </div>

            <div *ngIf="item.imageUrl.includes('medicineimages')">

              <img *ngIf="item.imageUrl" src="{{ serverPath1 }}/{{ item.imageUrl }}"
                class="product-img"
                onerror="this.src='assets/images/products/noImage/no-image.png';" />
            </div>

            <div *ngIf="item.imageUrl.includes('commonimages')">

              <img *ngIf="item.imageUrl" src="{{ serverPath7 }}/{{ item.imageUrl }}"
                class="product-img"
                onerror="this.src='assets/images/products/noImage/no-image.png';" />
            </div>
          </div>


          <div class="product-info" fxLayout="column" fxLayoutAlign="start start">
            <h3 class="product-title">{{ item.name }}</h3>
            <div class="product-price">
              <span class="sale-price">₹{{ item.price }}</span>
              <span class="original-price">₹{{ item.basePrice || item.price }}</span>
            </div>
            <!-- <div class="product-meta">
              {{ item.weight || '-' }} &nbsp;|&nbsp;
              {{ item.qty || '-' }} &nbsp;|&nbsp;
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>